import { render } from "./GraphQL-IntegratedDemo.vue?vue&type=template&id=482daa98"
import script from "./GraphQL-IntegratedDemo.vue?vue&type=script&lang=js"
export * from "./GraphQL-IntegratedDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__